export const limparMascara = (value) => {
  if (!value) return "";
  return value.replace(/\D/g, "");
};
